import React, { FC } from 'react'
import classNames from 'classnames'

import './SvgIcon.scss'

interface Props {
  name: string
  withOpacity?: boolean
  width?: number
  height?: number
  className?: string
  onClick?: () => void
}

export const SvgIcon: FC<Props> = ({ withOpacity = false, name, width, height, className = '', onClick }) => {
  const attributes = {
    style: {
      width: width && width,
      height: height && height,
    },
  }

  return (
    <svg
      id={`icon-${name}`}
      className={classNames(`icons-${name} icons-${name}-dims ${className}`, { 'with-opacity': withOpacity })}
      onClick={onClick}
      {...attributes}>
      <use xlinkHref={`#icons-${name}`} {...attributes} />
    </svg>
  )
}
